<app-uni-page [parent]="this" pageTitle="Documentation - Unwind &amp; Reconciliation" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full overflow-hidden">
    <div class="flex-1 overflow-auto px-4 pb-4">
      <div class="doc-markdown rounded border border-surface-200 bg-surface-50 p-6">
        <markdown [src]="mdSrc"></markdown>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
